export default __webpack_public_path__ + "static/media/logo_inpractice_default.c9315f22.svg";